import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import formWrapper from "../../../shared/Form";
import { Header, FilterOptions } from "../../../shared/GridComponents";
import { PostTagPicker } from "../../../shared/Forms";
import List from "./List";

class PostsUI extends Component {
	constructor(props) {
		super(props);
		this.url = props.match.url;
		this.push = props.history.push;
	}

	componentDidMount() {
		const { formApi, appKey } = this.props;
		const _values = localStorage.getItem(`postsFiltering-${appKey}`);
		const values = _values ? JSON.parse(_values) : {};
		if (formApi) formApi.setValues(values);
	}

	componentDidUpdate(prevProps) {
		const { values, appKey } = this.props;
		if (prevProps.values !== values) {
			localStorage.setItem(`postsFiltering-${appKey}`, JSON.stringify(values));
		}
	}

	deleteItem = id => {
		const { delete: remove } = this.props;
		remove(id);
	};

	createItem = () => {
		this.push(`${this.url}/new`);
	};

	duplicateItem = id => {
		this.push(`${this.url}/copy/${id}`);
	};

	editItem = id => {
		this.push(`${this.url}/${id}`);
	};

	render() {
		const { items, values } = this.props;

		const CRUD = {
			deleteItem: id => this.deleteItem(id),
			duplicateItem: id => this.duplicateItem(id),
			editItem: id => this.editItem(id),
		};

		const { postsFilter } = values;
		const filterBy = postsFilter ? postsFilter : [];

		return (
			<div>
				<Header createItem={this.createItem} pluralItemName="posts" />
				<FilterOptions>
					<PostTagPicker field="postsFilter" placeholder="Filter Posts" />
				</FilterOptions>
				<List crud={CRUD} filterBy={filterBy} items={items} />
			</div>
		);
	}
}

PostsUI.propTypes = {
	singleItemName: PropTypes.string,
	pluralItemName: PropTypes.string,
	match: PropTypes.object,
	items: PropTypes.array,
	delete: PropTypes.func,
	history: PropTypes.object,
	values: PropTypes.object.isRequired,
	formApi: PropTypes.object.isRequired,
	appKey: PropTypes.string.isRequired,
};

export default withRouter(formWrapper(PostsUI, false));
